<template>
    <div class="card">

        <div class="embed-responsive embed-responsive-16by9">
            <div :id="'liveChaserVideo_'+ streamId" class="embed-responsive-item" style="width: 100%; height: 100%;"></div>
        </div>

        <div class="w-full flex-col">
            <div>RTMP: {{ getLink('RTMP') }}</div>
            <div>HLS: {{ getLink('HLS') }}</div>
        </div>

    </div>
</template>

<script>

    import Clappr from 'clappr';

    export default {

        props: ['id', 'streamId'],

        data() {
            return {
                player: null,
                linkType: "RTMP",
                linkUrl: "rtmp://media-rtmp.hazcams.com/live/" + this.streamId,
            }
        },

        mounted() {
            this.initializePlayer();
        },

        methods: {
            initializePlayer() {
                var playerElement = document.getElementById("liveChaserVideo_" + this.streamId);

                this.player = new Clappr.Player({
                    sources: ["https://media-live.hazcams.com/hls/" + this.streamId + "/index.m3u8"],
                    autoPlay: true,
                    width: "100%",
                    height: "100%",
                    rtmpConfig: {
                        scaling:'stretch',
                        playbackType: 'live',
                        bufferTime: 1,
                        startLevel: 0,
                    },
                });
                this.player.attachTo(playerElement);
            },

            linkTypeFunc(link) {
                this.linkType = link;

                if(link == "RTMP") {
                    this.linkUrl = "rtmp://media-rtmp.hazcams.com/live/" + this.streamId;
                } else {
                    // link is hls
                    this.linkUrl = "https://media-live.hazcams.com/hls/" + this.streamId + "/index.m3u8";
                }

            },

            getLink(type) {
                if(type == "RTMP") {
                    return "rtmp://media-rtmp.hazcams.com/live/" + this.streamId;
                } else {
                    // link is hls
                    return "https://media-live.hazcams.com/hls/" + this.streamId + "/index.m3u8";
                }
            }
        },

        destroyed() {
            this.player.destroy();
        },

        ready() {

        },
    }
</script>

<style scoped>
    .embed-responsive {
        position: relative;
        display: block;
        width: 100%;
        padding: 0;
        overflow: hidden;
    }

    .embed-responsive-16by9::before {
        padding-top: 56.25%;
    }

    .embed-responsive::before {
        display: block;
        content: "";
    }

    .embed-responsive .embed-responsive-item, .embed-responsive embed, .embed-responsive iframe, .embed-responsive object, .embed-responsive video {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 0;
    }
</style>


<style scoped>
    .btn-primary-border {
        border: 1px solid #0069d9;
    }
    .card-header {
        font-weight: 600;
    }
    .stream-warning-header {
        text-align: center;
        padding: 5px 0px 5px 0px;
        background-color: #F44336;
        color: #fff;
    }
</style>
